import { Autocomplete } from "@mui/material";
import { AnalyticsCards } from "Common/Components/AnalyticsCards/AnalyticsCards";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import CustomStyle, { autocompleteDropdownStyles } from "Constants/Style";
import {
  ClipboardList,
  Package,
  PackageCheck,
  PackagePlus,
} from "lucide-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getWarehouseByUser } from "slices/Masters/warehosue/thunk";
import { MecordColors } from "Constants/Color";
import ListingPageContainer from "Common/Components/PageContainer/ListingPageContainer";
import IssuePacking from "pages/Warehouse/Packing/Listing/IssuePacking/IssuePacking";
import PackingDone from "./PackingDone/PackingDone";
import NoWarehousesMessage from "components/NoWarehouse/NoWarehouseMessage";

interface WarehousePackingProps {
  noWrapper?: boolean;
}

const WarehousePacking: React.FC<WarehousePackingProps> = ({ noWrapper = false }) => {
  document.title = "Packing";
  const dispatch = useDispatch<any>();
  const { tags: tagsParam } = useParams<{ tags?: string }>();
  const isTagSearch = Boolean(tagsParam && tagsParam.trim());
  const [hasAttemptedTagFetch, setHasAttemptedTagFetch] = useState(false);
  const [warehouseId, setWarehouseId] = useState<string | null>(() => {
    return sessionStorage.getItem("SelectedWarehouseId");
  });

  // Get warehouse dropdown data from Redux
  const { warehouseByUserList, warehouseByUserLoading } = useSelector(
    (state: any) => state.warehouse,
  );

  const user = useSelector((state: any) => state.Login.user);
  const packingDoneState = useSelector((state: any) => ({
    rowCount: state?.WarehousePackingDoneReducer?.rowCount ?? 0,
    dataLength: Array.isArray(state?.WarehousePackingDoneReducer?.list)
      ? state.WarehousePackingDoneReducer.list.length
      : 0,
    loading: Boolean(state?.WarehousePackingDoneReducer?.loading),
    error: state?.WarehousePackingDoneReducer?.error,
  }));
  const user_permissions = user?.data?.permissions || user?.permissions || [];
  const { app_modules } = require("helpers/apps_modules_list");
  const warehouse_permissions = user_permissions?.find(
    (item: any) => item?.apps_name === app_modules?.warehouse?.app_name,
  );

  const packing_permissions = warehouse_permissions?.modules_permissions?.find(
    (item: any) =>
      item?.modules_name === app_modules?.warehouse?.modules?.packing,
  );

  // useEffect(() => {
  //   if (warehouseByUserList?.length > 0 && warehouseId == null) {
  //     const savedWarehouseId = sessionStorage?.getItem("SelectedWarehouseId");
  //     if (
  //       savedWarehouseId &&
  //       warehouseByUserList.some(
  //         (w: any) => w.warehouse_id === savedWarehouseId,
  //       )
  //     ) {
  //       setWarehouseId(savedWarehouseId);
  //     } else {
  //       setWarehouseId(warehouseByUserList[0].warehouse_id);
  //       sessionStorage.setItem(
  //         "SelectedWarehouseId",
  //         warehouseByUserList[0].warehouse_id,
  //       );
  //     }
  //   }
  // }, [warehouseByUserList]);

  useEffect(() => {
    // 1️⃣ Reset if no warehouses assigned
    if (!warehouseByUserList?.length) {
      setWarehouseId(null);
      // sessionStorage.removeItem("SelectedWarehouseId");
      return;
    }

    // 2️⃣ Set default warehouse if none selected
    if (!warehouseId) {
      const savedWarehouse = sessionStorage.getItem("SelectedWarehouseId");
      if (
        savedWarehouse &&
        warehouseByUserList.some((w: any) => w.warehouse_id === savedWarehouse)
      ) {
        setWarehouseId(savedWarehouse);
      } else {
        const firstWarehouse = warehouseByUserList[0].warehouse_id;
        setWarehouseId(firstWarehouse);
        sessionStorage.setItem("SelectedWarehouseId", firstWarehouse);
      }
    }

    // 3️⃣ Listen for warehouse changes from other tabs
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "SelectedWarehouseId") {
        setWarehouseId(event.newValue);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [warehouseByUserList]);

  // Analytics cards data
  const statuses = useMemo(
    () => [
      {
        label: "Total Orders",
        icon: <ClipboardList size={18} />,
        bgColor: "bg-blue-50",
        textColor: "text-blue-600",
        count: 120,
        subLabel: "All orders",
      },
      {
        label: "Pending Packing",
        icon: <Package size={18} />,
        bgColor: "bg-yellow-50",
        textColor: "text-yellow-600",
        count: 35,
        subLabel: "Awaiting packing",
      },
      {
        label: "Partially Packed",
        icon: <PackagePlus size={18} />,
        bgColor: "bg-orange-50",
        textColor: "text-orange-600",
        count: 50,
        subLabel: "Partially completed",
      },
      {
        label: "Packing Completed",
        icon: <PackageCheck size={18} />,
        bgColor: "bg-green-50",
        textColor: "text-green-600",
        count: 82,
        subLabel: "Ready for dispatch",
      },
    ],
    [],
  );

  useEffect(() => {
    dispatch(getWarehouseByUser());
  }, [dispatch]);

  useEffect(() => {
    if (!noWrapper || !isTagSearch) {
      setHasAttemptedTagFetch(false);
      return;
    }
    // Mark as attempted once we enter a loading->settled cycle on tag-search route.
    if (packingDoneState.loading) {
      setHasAttemptedTagFetch(true);
    }
  }, [noWrapper, isTagSearch, packingDoneState.loading]);

  useEffect(() => {
    console.log("CURRENT WAREHOUSE ID", warehouseId);
  }, [warehouseId]);

  const sectionHeader = (
    <>
      <Row className="align-items-center g-2">
        <Col lg={3} className="me-auto">
          <h6 className="card-title mb-0">Packing</h6>
        </Col>
                  {/* Warehouse Dropdown Only */}
                  {/* <Col xs={12} md={6} lg={8} xl={6} className="">
                    <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 w-100">
                      <div className="hstack gap-2">
                        <div style={{ minWidth: "200px" }}>
                          <Autocomplete
                            options={warehouseByUserList ?? []}
                            loading={warehouseByUserLoading}
                            getOptionLabel={(option: any) =>
                              option?.warehouse_name || ""
                            }
                            value={
                              warehouseByUserList.find(
                                (opt: any) => opt.warehouse_id === warehouseId,
                              ) ?? null
                            }
                            isOptionEqualToValue={(option: any, value: any) =>
                              option.warehouse_id === value.warehouse_id
                            }
                            onChange={(_, selected) => {
                              clearAllTableStates()
                              const id = selected?.warehouse_id ?? null;
                              setWarehouseId(id);
                              sessionStorage.setItem(
                                "SelectedWarehouseId",
                                id ?? "",
                              );
                            }}
                            disableClearable
                            sx={{ ...CustomStyle?.singleselect, width: 300 }}
                            ListboxProps={
                              autocompleteDropdownStyles.ListboxProps
                            }
                            renderOption={(props, option) =>
                              autocompleteDropdownStyles.renderOption(
                                props,
                                option,
                                (opt) =>
                                  typeof opt === "string"
                                    ? opt
                                    : String(opt.warehouse_name),
                              )
                            }
                            renderInput={(params) => (
                              <BootstrapTextField
                                {...params}
                                name="warehouse"
                                placeholder="Select Warehouse"
                                fullWidth
                                size="small"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                      borderColor: `${MecordColors?.ThemeBGColor} !important`,
                                    },
                                    "&:hover fieldset": {
                                      borderColor: `${MecordColors?.ThemeBGColor} !important`,
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: `${MecordColors?.ThemeBGColor} !important`,
                                    },
                                    fontFamily: "Poppins, sans-serif",
                                    fontSize: "13px",
                                  },
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </Col> */}
      </Row>
    </>
  );

  const sectionBody =
    warehouseByUserList.length === 0 && !isTagSearch ? (
      <NoWarehousesMessage />
    ) : (
      <PackingDone
        key={`packingDone-${warehouseId}`}
        warehouseId={warehouseId}
        noWrapper={noWrapper}
      />
    );

  const hideTagsSearchPackingSection =
    noWrapper &&
    isTagSearch &&
    hasAttemptedTagFetch &&
    !packingDoneState.loading &&
    !packingDoneState.error &&
    packingDoneState.rowCount === 0 &&
    packingDoneState.dataLength === 0;

  if (hideTagsSearchPackingSection) {
    return null;
  }

  if (noWrapper) {
    return (
      <>
        {sectionHeader}
        <div className="mt-4">{sectionBody}</div>
      </>
    );
  }

  return (
    <ListingPageContainer className="pt-0">
      <Row id="listPage">
        <Col lg={12}>
          <Card style={{ boxShadow: "none" }}>
            <Card.Header>{sectionHeader}</Card.Header>
            <Card.Body>{sectionBody}</Card.Body>
          </Card>
        </Col>
      </Row>
    </ListingPageContainer>
  );
};

export default WarehousePacking;
